import { GET_CAROUSEL_ITEMS } from 'constants/carousel';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const carouselReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${GET_CAROUSEL_ITEMS}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${GET_CAROUSEL_ITEMS}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${GET_CAROUSEL_ITEMS}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
